<template>
	<div v-loading="loading" class="operation_module_training base_scroll_page" style="padding: 15px 15px 15px 200px;">
		<!-- 区域选择 -->
		<area-choise @nodeClick="handleAreaChoiseSelect"></area-choise>
		<!-- 区域选择 end -->
		
		<div class="b_scroller">
			<!-- 查询条件 -->
			<div class="base_inquire">
				<div class="b_item">
					<span class="b_label">姓名：</span>
					<el-input v-model="name" class="b_inp" placeholder="姓名"></el-input>
				</div>
				
				<div class="b_item">
					<span class="b_label">账号：</span>
					<el-input v-model="code" class="b_inp" placeholder="账号"></el-input>
				</div>
				
				<div class="b_item">
					<span class="b_label">用户类型：</span>
					<el-select v-model="disease" class="b_inp" placeholder="请选择" :clearable="true">
						<el-option v-for="v in allDisease" :key="v.id" :value="v.id" :label="v.name"></el-option>
					</el-select>
				</div>
				
				<div class="b_item">
					<span class="b_label">注册医院：</span>
					<el-input v-model="hospital" class="b_inp" placeholder="注册医院"></el-input>
				</div>
				
				<div class="b_item">
					<span class="b_label">开始时间：</span>
					<el-date-picker
						v-model="startTime"
						:editable="false"
						placeholder="开始时间"
						type="datetime"
						value-format="yyyy-MM-dd HH:mm:ss"
						@change="handleSearchStartTimeClick"
					>
					</el-date-picker>
				</div>
				
				<div class="b_item">
					<span class="b_label">结束时间：</span>
					<el-date-picker
						v-model="endTime"
						:editable="false"
						placeholder="结束时间"
						type="datetime"
						value-format="yyyy-MM-dd HH:mm:ss"
						@change="handleSearchEndTimeClick"
					>
					</el-date-picker>
				</div>
				
				<el-button type="primary" @click="handleSearchClick">查询</el-button>
			</div>
			<!-- 查询条件 end -->
			
			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table
					:data="tableData"
					style="width: 100%"
				>
					<el-table-column
						prop="diseaseName"
						label="类型"
					>
					</el-table-column>
					<el-table-column
						prop="code"
						label="账号"
					>
					</el-table-column>
					<el-table-column
						prop="name"
						label="姓名"
					>
					</el-table-column>
					<el-table-column
						prop="sexLabel"
						label="性别"
					>
					</el-table-column>
					<el-table-column
						prop="doctorName"
						label="主治医师"
					>
					</el-table-column>
					<el-table-column
						prop="hospitalName"
						label="就诊医院"
					>
					</el-table-column>
					<el-table-column
						prop="creater"
						label="注册人"
					>
					</el-table-column>
					<el-table-column
						prop="creatDate"
						label="注册时间"
					>
					</el-table-column>
					<el-table-column
						label="操作"
						width="350"
					>
						<template slot-scope="scope">
							<el-button
								@click="handleViewClick(scope.row)"
							>查看</el-button>
							<el-button
								@click="handleResetTrainingClick(scope.row)"
							>重置训练难度</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
			
			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination
						layout="total, prev, pager, next, jumper"
						next-text="下一页" 
						:total="total"
						:current-page="currentPage"
						@current-change="handlePageChange"
					>
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>
		
		<!-- 查看 -->
		<task-view v-model="taskView_display" :uid="taskView_uid"></task-view>
		<!-- 查看 end -->
		
		<!-- 重置训练难度 -->
		<reset-training v-model="resetTraining_display" :uid="resetTraining_uid"></reset-training>
		<!-- 重置训练难度 end -->
	</div>
</template>

<script>
	import Api from '../../../../../api/index.js';
	import { mapState } from 'vuex';
	import AreaChoise from '../../components/area_choise.vue';
	import BaseMethods from '../../../../../assets/js/base.js';
	import TaskView from './components/view.vue';
	import ResetTraining from './components/reset_training.vue';
	
	export default{
		mounted() {
			this.getList();
		},
		data() {
			return{
				loading: false,
				provinceName: '',
				provinceCode: '',
				cityName: '',
				cityCode: '',
				areaName: '',
				areaCode: '',
				name: '',
				code: '',
				disease: '',
				hospital: '',
				startTime: '',
				endTime: '',
				currentPage: 1,
				total: 0,
				
				tableData: [],
				
				taskView_display: false,
				taskView_uid: '',
				
				resetTraining_display: false,
				resetTraining_uid: ''
			}
		},
		computed: {
			...mapState([
				'authInfo',
				'allDisease'
			])
		},
		methods: {
			/***************************** @Function *******************************/
			// 选择城市
			handleAreaChoiseSelect (data) {
				if (data.sign == "P") {
					this.provinceCode = data.key.slice(0, 3);
					this.provinceName = data.label;
					this.cityCode = '';
					this.cityName = '';
					this.areaCode = '';
					this.areaName = '';
					this.currentPage = 1;
					this.getList();
				} else if (data.sign == "C") {
					this.provinceCode = data.parentKey.slice(0, 3);
					this.provinceName = data.parentLabel;
					this.cityCode = data.key + '000000';
					this.cityName = data.label;
					this.areaCode = '';
					this.areaName = '';
					this.currentPage = 1;
					this.getList();
				} else if (data.sign == "A") {
					this.provinceCode = data.grandKey.slice(0, 3);
					this.provinceName = data.grandLabel;
					this.cityCode = data.parentKey + '000000';
					this.cityName = data.parentLabel;
					this.areaCode = data.key + '000000';
					this.areaName = data.label;
					this.currentPage = 1;
					this.getList();
				} else {
					this.provinceCode = '';
					this.provinceName = '';
					this.cityCode = '';
					this.cityName = '';
					this.areaCode = '';
					this.areaName = '';
					this.currentPage = 1;
					this.getList();
				}
			},
			// 切换开始时间
			handleSearchStartTimeClick() {
				this.compareSearchTime();
			},
			// 切换结束时间
			handleSearchEndTimeClick() {
				this.compareSearchTime();
			},
			// 点击查询
			handleSearchClick() {
				this.currentPage = 1;
				this.getList();
			},
			// 点击页码
			handlePageChange (page) {
				if (this.currentPage != page) {
					this.currentPage = page;
					this.getList();
				}
			},
			// 点击查看
			handleViewClick(obj) {
				this.taskView_uid = obj.id;
				this.taskView_display = true;
			},
			// 点击重置任务难度
			handleResetTrainingClick(obj) {
				this.resetTraining_uid = obj.id;
				this.resetTraining_display = true;
			},
			
			/***************************** @Function *******************************/
			// 请求数据
			getList() {
				const that = this;
				that.loading = true;
				var _requestData = {
					creater: null,
					endTime: that.endTime,
					limit: 10,
					pageNum: that.currentPage,
					startTime: that.startTime,
					uareaName: that.areaName,
					ucityName: that.cityName,
					ucode: that.code,
					udiseasesId: that.disease,
					uenterpriseName: that.hospital,
					ufinderCategory: null,
					uid: null,
					uloginerCategory: that.authInfo.ucategory,
					uphone: null,
					uprovinceName: that.provinceName,
					username: that.name,
					userId: that.authInfo.uid,
					uenterpriseId: that.authInfo.uenterpriseId,
					functionType: 1
				};
				Api.findUser(_requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.total = res.data.data.totalItems;
						let list = [];
						for (var i = 0;i < res.data.data.data.length;i++) {
							list.push({
								id: res.data.data.data[i].uid,
								agencyId: res.data.data.data[i].uenterpriseId,
								diseaseId: res.data.data.data[i].udiseasesId || '',
								diseaseName: res.data.data.data[i].udiseasesName || '',
								code: res.data.data.data[i].ucode || '',
								name: res.data.data.data[i].name || '',
								phone: res.data.data.data[i].phone || '',
								sex: res.data.data.data[i].sex || '',
								sexLabel: res.data.data.data[i].sex == 0
										? '男'
										: res.data.data.data[i].sex == 1
											? '女'
											: '',
								age: res.data.data.data[i].age || '',
								doctorId: res.data.data.data[i].uattendingDoctor || '',
								doctorName: res.data.data.data[i].doctorName || '',
								hospitalId: res.data.data.data[i].uenterpriseId || '',
								hospitalName: res.data.data.data[i].uenterpriseName || '',
								creater: res.data.data.data[i].creater || '',
								creatDate: res.data.data.data[i].createTime ? res.data.data.data[i].createTime.split("T")[0] : '',
								provinceName: res.data.data.data[i].uenterpriseProvinceName || '',
								provinceCode: res.data.data.data[i].uenterpriseProvinceCode || '',
								cityName: res.data.data.data[i].uenterpriseCityName || '',
								cityCode: res.data.data.data[i].uenterpriseCityCode || '',
								areaName: res.data.data.data[i].uenterpriseAreaName || '',
								areaCode: res.data.data.data[i].uenterpriseAreaCode || '',
								nakedR: res.data.data.data[i].urightNeva || '',
								nakedL: res.data.data.data[i].uleftNeva || '',
								correctionR: res.data.data.data[i].urightCva || '',
								correctionL: res.data.data.data[i].uleftCva || '',
								cover: res.data.data.data[i].uoverspreadEye ? parseInt(res.data.data.data[i].uoverspreadEye) : -1,
								coverName: BaseMethods.mapCoverToName(res.data.data.data[i].uoverspreadEye),
								remark: res.data.data.data[i].memo || ''
							});
						}
						that.tableData = list;
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 比较开始时间和结束时间
			compareSearchTime () {
				if (this.startTime && this.endTime) {
					var startTime = new Date(this.startTime).getTime(),
						endTime = new Date(this.endTime).getTime();
					if (endTime < startTime) {
						this.endTime = '';
						this.$message.warning('结束时间不能小于开始时间');
					}
				}
			}
		},
		components: {
			AreaChoise,
			TaskView,
			ResetTraining
		}
	}
</script>

<style scoped>
</style>
